import React from "react";

import { useLocation } from "react-router-dom";

import { svgs } from "../../../assets";

import { RegisterSideBar } from "../../sidebar";

import * as S from "./styles";

import IProps from "./props";

const RegisterDeveloperLayout: React.FC<IProps> = ({ children }) => {
  const { pathname } = useLocation();
  const [, , step] = pathname.split("/");

  const [currentStep, setCurrentStep] = React.useState<number>(0);

  React.useEffect(() => {
    if (step) setCurrentStep(Number(step));
  }, [step]);

  return (
    <S.Container>
      <S.Header>
        <img alt="logo" src={svgs.LucralizeLogo} />
      </S.Header>
      <RegisterSideBar currentStep={currentStep} />
      <S.Main>{children}</S.Main>
    </S.Container>
  );
};

export default RegisterDeveloperLayout;
